<template>
  <r-data-list
    :headdata="headdata"
    :listdata="filteredList"
    :opt="opts"
    v-if="loaded"
    :searchfilter="searchfilter"
    v-model:qu="q"
    ><template v-slot:nodatain>
      <r-select
        v-model="selectedcat"
        label="Branş"
        :data="branchList.data"
        txt="title"
        val="id"
        width="30%"
        style="color: rgb(17, 17, 17)"
      >
        <template v-slot:itemtxt="{ data }">
          {{ data.id + "_" + data.title }}
        </template>
      </r-select>
    </template>
    <template v-slot:titleextrabuttons>
      <r-select
        v-model="selectednote"
        label="Not Durumu"
        :data="noteSelect"
        txt="txt"
        val="val"
        width="30%"
    /></template>
    <template v-slot:titleextrabuttonsafter>
      <r-btn bgcolor="#55110d" @click="openCats">Ders Notu Kategorileri</r-btn>
    </template>
    <template v-slot:title>
      <r-flex align="flex-start center">
        <r-select
          v-model="selectedcat"
          label="Branş"
          :data="branchList.data"
          txt="title"
          val="id"
          width="30%"
        >
          <template v-slot:itemtxt="{ data }">
            {{ data.id + "_" + data.title }}
          </template>
        </r-select>
        <h3>Ders Notları</h3>
      </r-flex>
    </template>
    <template v-slot:col6="{ datarow }">
      <span class="r-check-ok small" v-if="datarow.isActive === true"></span>
      <span class="r-check-no small" v-else></span>
    </template>
  </r-data-list>
  <r-panel
    :title="'Yeni Ders Notu Ekle'"
    v-if="newPanel"
    v-model:isactive="newPanel"
    classes="r-flx-dw-80"
    pos="center"
  >
    <r-flex>
      <r-checkbox v-model="newData.isActive" label="Aktif mi?" />
    </r-flex>
    <r-flex>
      <r-select
        v-model="newData.categoryId"
        label="Branş"
        :data="branchList.data"
        txt="title"
        val="id"
        class="r-mb-16"
      />
      <r-select
        v-model="newData.categoryTypeId"
        label="Kategori"
        :data="noteCats.data"
        txt="name"
        val="id"
        class="r-mb-16"
      />
      <r-input v-model="newData.name" label="Ders Notu Adı" class="r-mb-16" />
      <r-flex>
        <r-flex flx="4" class="r-pr-32">
          <r-select
            v-model="newData.fassiculeCount"
            label="Fasikül Sayısı"
            :data="fassiculeCount"
            @change="fassiculeChange"
          />
        </r-flex>
        <r-flex flx="8">
          <r-flex
            v-for="(pages, i, k) in newData.pages"
            :key="i"
            align="center"
            class="r-mb-16"
          >
            <r-flex flx="2" align="center">
              <strong>{{ "Fasikül " + (k + 1) + " : " }}</strong>
            </r-flex>
            <r-flex flx="10" align="center">
              <r-input
                v-for="(inp, j) in pages"
                :key="j"
                v-model="newData.pages[i][j]"
                :label="(j === 0 ? 'Başlangıç' : 'Bitiş') + ' Sayfa No'"
                width="45%"
              />
            </r-flex>
          </r-flex>
        </r-flex>
      </r-flex>
      <r-flex>
        <r-btn bgcolor="#15880d" @click="saveNew" :disabled="canSaveNote"
          >Kaydet</r-btn
        >
      </r-flex>
      <r-flex
        class="r-mt-32"
        style="border-top: 2px solid #ccc; padding-top: 16px;"
      >
        <r-flex
          flx="12"
          class="r-mb-16"
          style="display: flex; gap: 16px; align-items: flex-start;"
        >
          <r-input
            v-model="previewPageNo"
            label="Sayfa No Önizleme"
            type="number"
            width="30%"
            @input="onPreviewPageNoChange"
          />
          <div style="flex: 1; min-width: 0;">
            <label style="display: block; margin-bottom: 8px; font-weight: 600;"
              >Klasördeki Resimler</label
            >
            <div
              v-if="loadingImages"
              style="padding: 16px; text-align: center; color: #666;"
            >
              Resimler yükleniyor...
            </div>
            <div
              v-else-if="
                previewPageNo && newData.id && imageFileNames.length === 0
              "
              style="padding: 16px; text-align: center; color: #999;"
            >
              Bu klasörde resim bulunamadı.
            </div>
            <div v-else class="image-scroll-container">
              <div
                v-for="(fileName, index) in imageFileNames"
                :key="index"
                class="image-item"
                :class="{ selected: selectedImageFileName === fileName }"
                @click="selectImage(fileName)"
              >
                <img
                  :src="getImageUrl(fileName)"
                  :alt="fileName"
                  @error="onThumbnailError"
                />
                <span class="image-filename">{{ fileName }}</span>
              </div>
              <div class="image-item image-item-add" @click="triggerFileInput">
                <div class="add-image-placeholder">
                  <span style="font-size: 24px;">+</span>
                  <span style="font-size: 12px; margin-top: 4px;"
                    >Resim Ekle</span
                  >
                </div>
              </div>
            </div>
            <input
              ref="fileInputRef"
              type="file"
              accept="image/*"
              style="display: none"
              @change="handleFileUpload"
            />
          </div>
        </r-flex>
        <r-flex flx="12" v-if="previewImageUrl">
          <img
            :src="previewImageUrl"
            alt="Sayfa Önizleme"
            style="max-width: 100%; border: 1px solid #ccc; border-radius: 4px;"
            @error="onImageError"
          />
        </r-flex>
        <r-flex
          flx="12"
          v-if="previewPageNo && !previewImageUrl && !imageError"
        >
          <span style="color: #666;">Resim yükleniyor...</span>
        </r-flex>
        <r-flex flx="12" v-if="imageError">
          <span style="color: #d32f2f;"
            >Resim bulunamadı veya yüklenemedi.</span
          >
        </r-flex>
      </r-flex>
    </r-flex>
  </r-panel>
  <r-panel
    title="Ders Notu Kategorileri"
    v-if="catsPanel"
    v-model:isactive="catsPanel"
    pos="center"
    width="50%"
    classes="r-flx-dw-80"
  >
    <r-data-list
      :headdata="catsheaddata"
      :listdata="catsListData.data"
      :opt="catsopts"
      v-if="catsloaded"
      :searchfilter="searchcatsfilter"
      v-model:qu="qc"
    />
  </r-panel>

  <!-- Varsayılan Resim Onay Modal -->
  <r-panel
    title="Resmi Varsayılan Yap"
    v-if="showDefaultImageModal"
    v-model:isactive="showDefaultImageModal"
    pos="center"
    width="420px"
    classes="default-image-modal"
  >
    <r-flex direction="column" class="r-p-24 default-image-modal-content">
      <div class="default-image-modal-text">
        <p class="default-image-modal-title">
          Seçtiğiniz resmi varsayılan (orijinal) resim olarak ayarlamak istiyor
          musunuz?
        </p>
        <div class="default-image-modal-box">
          <div class="default-image-modal-row">
            <strong>Mevcut Varsayılan:</strong>
            <div class="default-image-modal-old">
              {{ modalOriginalFileName }}
            </div>
          </div>
          <div class="default-image-modal-row">
            <strong>Yeni Varsayılan:</strong>
            <div class="default-image-modal-new">
              {{ modalSelectedFileName }}
            </div>
          </div>
        </div>
        <div class="default-image-modal-note">
          <strong>Not:</strong> Mevcut varsayılan resim yedeklenecek ve
          seçtiğiniz resim varsayılan isme çevrilecektir.
        </div>
      </div>

      <r-flex justify="flex-end" gap="12px" class="default-image-modal-actions">
        <r-btn
          bgcolor="#757575"
          @click="showDefaultImageModal = false"
          :disabled="modalProcessing"
        >
          İptal
        </r-btn>
        <r-btn
          bgcolor="#2e7d32"
          @click="confirmSetDefaultImage"
          :disabled="modalProcessing"
        >
          <span v-if="modalProcessing">İşleniyor...</span>
          <span v-else>Evet, Varsayılan Yap</span>
        </r-btn>
      </r-flex>
    </r-flex>
  </r-panel>
</template>
<script>
import { onBeforeMount, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { trToUpper } from "@/mix/global";
export default {
  setup() {
    const store = useStore();
    const listData = ref({});
    const catsListData = ref({});
    const branchList = ref({});
    const noteCats = ref({});
    const loaded = ref(false);
    const catsloaded = ref(false);
    const selectedcat = ref(null);
    const selectedAddCat = ref(null);
    const newPanel = ref(false);
    const newData = ref({});
    const fassiculeCount = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
    const catsPanel = ref(false);
    const q = ref("");
    const qc = ref("");
    const selectednote = ref(null);
    const noteSelect = ref([
      { txt: "Tümü", val: null },
      { txt: "Aktif", val: true },
      { txt: "Pasif", val: false }
    ]);
    const previewPageNo = ref(null);
    const previewImageUrl = ref(null);
    const imageError = ref(false);
    const imageFileNames = ref([]);
    const loadingImages = ref(false);
    const selectedImageFileName = ref(null);
    const fileInputRef = ref(null);
    const uploadingImage = ref(false);

    // Modal state'leri
    const showDefaultImageModal = ref(false);
    const modalOriginalFileName = ref(null);
    const modalSelectedFileName = ref(null);
    const modalProcessing = ref(false);
    const searchfilter = v => {
      return (
        trToUpper(v.name).includes(trToUpper(q.value)) ||
        trToUpper(v.categoryTypeName).includes(trToUpper(q.value))
      );
    };
    const selectfilter = v => {
      return v.isActive === selectednote.value;
    };

    const searchcatsfilter = v => {
      return (
        trToUpper(v.name).includes(trToUpper(qc.value)) ||
        trToUpper(v.title).includes(trToUpper(qc.value)) ||
        trToUpper(v.description).includes(trToUpper(qc.value))
      );
    };
    const canSaveNote = computed(() => {
      if (
        newData.value.categoryId !== null &&
        newData.value.categoryId !== undefined &&
        newData.value.categoryId !== "" &&
        newData.value.categoryTypeId !== null &&
        newData.value.categoryTypeId !== undefined &&
        newData.value.categoryTypeId !== "" &&
        newData.value.name !== null &&
        newData.value.name !== undefined &&
        newData.value.name !== "" &&
        newData.value.fassiculeCount !== null &&
        newData.value.fassiculeCount !== undefined &&
        newData.value.fassiculeCount !== "" &&
        controlFassicules.value
      )
        return false;
      else return true;
    });
    const controlFassicules = computed(() => {
      var isok = true;
      if (newData.value.pages !== undefined) {
        Object.keys(newData.value.pages).forEach(k => {
          newData.value.pages[k].forEach(val => {
            if (val === undefined || val === "") isok = false;
          });
        });
      }
      return isok;
    });
    const filteredList = computed(() => {
      if (selectedcat.value !== null && listData.value.data) {
        if (selectednote.value === null) {
          return listData.value.data.filter(searchfilter);
        } else {
          return listData.value.data.filter(searchfilter).filter(selectfilter);
        }
      } else {
        return [];
      }
    });

    const headdata = computed(() => {
      return [
        {
          title: "ID",
          style: { width: "5%" },
          key: "id"
        },
        {
          title: "Adı",
          style: { width: "35%" },
          key: "name"
        },
        {
          title: "Tür",
          style: { width: "20%", justifyContent: "center" },
          key: "categoryTypeName"
        },
        {
          title: "Fasikül Sayısı",
          style: { width: "10%", justifyContent: "center" },
          key: "fassiculeCount"
        },
        {
          title: "Sayfa No",
          style: { width: "20%" },
          key: "pageNo"
        },
        {
          title: "Aktif mi?",
          style: { width: "10%", justifyContent: "center" },
          key: "isActive"
        }
      ];
    });
    const opts = ref({
      title: "Ders Notları",
      nodatatxt: () => {
        return selectedcat.value === null
          ? "Lütfen branş seçiniz"
          : listData.value.data && listData.value.data.length === 0
          ? "Sonuç bulunamadı"
          : "";
      },
      buttons: {
        style: { width: "15%" },
        edit: {
          show: true,
          type: "out",
          func: d => {
            editFunc(d);
          }
        },
        delete: {
          show: true,
          func: d => {
            deleteFunc(d);
          }
        },
        add: {
          show: true,
          type: "out",
          func: d => {
            addFunc(d);
          }
        }
      }
    });
    const catsheaddata = computed(() => {
      return [
        {
          title: "Adı",
          style: { width: "20%" },
          key: "name",
          valid: "required"
        },
        {
          title: "Başlık",
          style: { width: "30%", justifyContent: "center" },
          key: "title",
          type: "textarea"
        },
        {
          title: "Açıklama",
          style: { width: "35%", justifyContent: "center" },
          key: "description",
          type: "textarea"
        }
      ];
    });
    const catsopts = ref({
      title: "Ders Notu kategorileri",
      buttons: {
        style: { width: "15%" },
        edit: {
          show: true,
          type: "in",
          savefunc: d => {
            editCatsFunc(d);
          }
        },
        delete: {
          show: true,
          func: d => {
            deleteCatsFunc(d);
          }
        },
        add: {
          show: true,
          type: "in",
          func: d => {
            addCatsFunc(d);
          }
        }
      }
    });
    const getList = async () => {
      let list = await store.dispatch("getDatas", {
        api: "notes/getnotesbycategory",
        params: {
          categoryid: selectedcat.value,
          isActive: false
        }
      });
      return list;
    };
    const getBranchList = async () => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: {
          pid: 0
        }
      });
      return list;
    };
    const getCatsList = async () => {
      let list = await store.dispatch("getDatas", {
        api: "notes/getnotecategories"
      });
      return list;
    };
    const addFunc = async () => {
      newData.value = {};
      newData.value.pages = {};
      newData.value.categoryId = selectedcat.value;
      previewPageNo.value = null;
      previewImageUrl.value = null;
      imageError.value = false;
      imageFileNames.value = [];
      selectedImageFileName.value = null;
      loadingImages.value = false;
      newPanel.value = true;
    };
    const editFunc = async d => {
      newData.value = d.row;
      let f = d.row.pageNo.split("#");
      newData.value.pages = {};
      f.forEach((v, i) => {
        newData.value.pages["f" + i] = v.split("-");
      });
      previewPageNo.value = null;
      previewImageUrl.value = null;
      imageError.value = false;
      imageFileNames.value = [];
      selectedImageFileName.value = null;
      loadingImages.value = false;
      newPanel.value = true;
    };
    const deleteFunc = async d => {
      await store.dispatch("postDatas", {
        api: "notes/deletenote",
        data: { id: parseInt(d.row.id) }
      });
      listData.value = await getList();
    };
    const addCatsFunc = async d => {
      await store.dispatch("postDatas", {
        api: "notecategories/addnotecategory",
        data: d
      });
      catsListData.value = await getCatsList();
      noteCats.value = await getCatsList();
    };
    const editCatsFunc = async d => {
      d.id = parseInt(d.id);
      await store.dispatch("postDatas", {
        api: "notecategories/addnotecategory",
        data: d
      });
      catsListData.value = await getCatsList();
      noteCats.value = await getCatsList();
    };
    const deleteCatsFunc = async d => {
      await store.dispatch("postDatas", {
        api: "notecategories/deletenotecategory",
        data: { id: parseInt(d.row.id) }
      });
      catsListData.value = await getCatsList();
      noteCats.value = await getCatsList();
    };
    const fassiculeChange = d => {
      let ol = Object.keys(newData.value.pages).length;

      if (ol > d) {
        for (let j = d; j < ol; j++) {
          delete newData.value.pages["f" + j];
        }
      } else {
        for (let i = ol; i < d; i++) {
          newData.value.pages["f" + i] = ["", ""];
        }
      }
    };
    const onPreviewPageNoChange = async () => {
      console.log(
        "[DEBUG] onPreviewPageNoChange - called with previewPageNo:",
        previewPageNo.value
      );
      imageError.value = false;
      previewImageUrl.value = null;
      imageFileNames.value = [];
      selectedImageFileName.value = null;

      if (!previewPageNo.value || previewPageNo.value === "") {
        console.log(
          "[DEBUG] onPreviewPageNoChange - previewPageNo is empty, returning"
        );
        return;
      }

      // categoryId ve id (lessonNoteId) kontrolü
      if (!newData.value.categoryId) {
        imageError.value = true;
        return;
      }

      // Yeni ekleme modunda id yoksa resim gösterilemez
      if (!newData.value.id) {
        imageError.value = true;
        return;
      }

      // PageExport.vue'daki formülü kullanıyoruz
      const pageNoFormatted = parseInt(previewPageNo.value)
        .toString()
        .padStart(3, "0");
      const url =
        "https://referans.tusem.com.tr/referansnotlari/" +
        store.state.workFolder +
        "/ref_img_" +
        store.state.usertype +
        "/" +
        newData.value.categoryId +
        "/" +
        newData.value.id +
        "/" +
        pageNoFormatted +
        ".jpg";

      previewImageUrl.value = url;

      // Klasördeki resimleri yükle
      await loadImageFileNames();
    };
    const loadImageFileNames = async () => {
      console.log("[DEBUG] loadImageFileNames - called");
      console.log(
        "[DEBUG] loadImageFileNames - categoryId:",
        newData.value.categoryId,
        "id:",
        newData.value.id,
        "previewPageNo:",
        previewPageNo.value
      );

      if (!newData.value.categoryId || !newData.value.id) {
        console.log(
          "[DEBUG] loadImageFileNames - categoryId or id missing, returning"
        );
        return;
      }

      if (!previewPageNo.value || previewPageNo.value === "") {
        console.log(
          "[DEBUG] loadImageFileNames - previewPageNo is empty, returning"
        );
        return;
      }

      loadingImages.value = true;
      imageFileNames.value = [];

      try {
        // Sayfa numarasını 3 haneli formatla (örn: 77 → 077)
        const pageNoFormatted = parseInt(previewPageNo.value)
          .toString()
          .padStart(3, "0");

        // Klasör yolu: referansnotlari\{workFolder}\ref_img_{usertype}\{categoryId}\{lessonNoteId}\{pageNo}
        const folderPath =
          "referansnotlari/" +
          store.state.workFolder +
          "/ref_img_" +
          store.state.usertype +
          "/" +
          newData.value.categoryId +
          "/" +
          newData.value.id +
          "/" +
          pageNoFormatted;

        console.log("[DEBUG] loadImageFileNames - folderPath:", folderPath);
        console.log("[DEBUG] loadImageFileNames - API call starting...");

        const result = await store.dispatch("getDatas", {
          api: "References/GetImageFileNames",
          params: { folderPath: folderPath }
        });

        console.log("[DEBUG] loadImageFileNames - API response:", result);

        if (result && result.result && result.data) {
          imageFileNames.value = result.data;
        }
      } catch (error) {
        console.error("Resim listesi yüklenirken hata:", error);
      } finally {
        loadingImages.value = false;
      }
    };
    const getImageUrl = fileName => {
      if (
        !newData.value.categoryId ||
        !newData.value.id ||
        !previewPageNo.value
      ) {
        return "";
      }

      // Backend'den gelen dosya adı zaten tam dosya adı (örn: 003.jpg veya 003_a.jpg)
      // Dosya direkt lessonNoteId klasöründe duruyor, sayfa numarası klasörü yok
      // URL: .../968/003.jpg (sayfa numarası klasörü YOK)
      return (
        "https://referans.tusem.com.tr/referansnotlari/" +
        store.state.workFolder +
        "/ref_img_" +
        store.state.usertype +
        "/" +
        newData.value.categoryId +
        "/" +
        newData.value.id +
        "/" +
        fileName
      );
    };
    // Orijinal resim adını bul (sayfa numarası ile başlayan ve timestamp içermeyen)
    const findOriginalImageName = () => {
      if (!previewPageNo.value || imageFileNames.value.length === 0) {
        return null;
      }

      const pageNoFormatted = parseInt(previewPageNo.value)
        .toString()
        .padStart(3, "0");

      // Orijinal resim: sayfa numarası ile başlayan ve timestamp içermeyen (örn: 003.jpg)
      const originalImage = imageFileNames.value.find(fileName => {
        const nameWithoutExt = fileName.replace(/\.[^/.]+$/, ""); // Uzantıyı çıkar
        // Sayfa numarası ile başlıyor mu ve timestamp içermiyor mu kontrol et
        return (
          nameWithoutExt.startsWith(pageNoFormatted) &&
          !nameWithoutExt.includes("_") // Timestamp genelde _ ile ayrılır
        );
      });

      return originalImage || null;
    };

    const selectImage = fileName => {
      selectedImageFileName.value = fileName;

      // Orijinal resim adını bul
      const originalFileName = findOriginalImageName();

      // Eğer seçilen resim zaten orijinal ise, işlem yapma
      if (fileName === originalFileName) {
        console.log(
          "[DEBUG] selectImage - Seçilen resim zaten orijinal, işlem yapılmıyor"
        );
        return;
      }

      // Eğer orijinal resim bulunamadıysa, uyarı ver
      if (!originalFileName) {
        console.log("[DEBUG] selectImage - Orijinal resim bulunamadı");
        alert("Orijinal resim bulunamadı. Bu resmi varsayılan yapamazsınız.");
        return;
      }

      // Modal'ı aç
      modalOriginalFileName.value = originalFileName;
      modalSelectedFileName.value = fileName;
      showDefaultImageModal.value = true;
    };

    const confirmSetDefaultImage = async () => {
      if (!modalOriginalFileName.value || !modalSelectedFileName.value) {
        return;
      }

      modalProcessing.value = true;

      try {
        const pageNoFormatted = parseInt(previewPageNo.value)
          .toString()
          .padStart(3, "0");

        const folderPath =
          "referansnotlari/" +
          store.state.workFolder +
          "/ref_img_" +
          store.state.usertype +
          "/" +
          newData.value.categoryId +
          "/" +
          newData.value.id +
          "/" +
          pageNoFormatted;

        console.log("[DEBUG] confirmSetDefaultImage - API çağrısı yapılıyor:", {
          folderPath,
          originalFileName: modalOriginalFileName.value,
          selectedFileName: modalSelectedFileName.value
        });

        // POST endpoint için query string parametrelerini URL'e ekle
        const apiUrl = `References/SetDefaultImage?folderPath=${encodeURIComponent(
          folderPath
        )}&originalFileName=${encodeURIComponent(
          modalOriginalFileName.value
        )}&selectedFileName=${encodeURIComponent(modalSelectedFileName.value)}`;

        const result = await store.dispatch("postDatas", {
          api: apiUrl,
          data: {} // POST body boş, parametreler query string'de
        });

        console.log("[DEBUG] confirmSetDefaultImage - API response:", result);

        if (result && result.result === true) {
          // Modal'ı kapat
          showDefaultImageModal.value = false;
          modalProcessing.value = false;

          // Başarı mesajı göster
          alert("Resim başarıyla varsayılan olarak ayarlandı!");

          // Resim listesini yenile
          imageFileNames.value = [];
          await new Promise(resolve => setTimeout(resolve, 500));
          await loadImageFileNames();
        } else {
          alert(
            "Resim varsayılan yapılırken bir hata oluştu: " +
              (result?.message || "Bilinmeyen hata")
          );
          modalProcessing.value = false;
        }
      } catch (error) {
        console.error(
          "[ERROR] confirmSetDefaultImage - API çağrısı hatası:",
          error
        );
        alert("Resim varsayılan yapılırken bir hata oluştu: " + error.message);
        modalProcessing.value = false;
      }
    };
    const onImageError = () => {
      imageError.value = true;
      previewImageUrl.value = null;
    };
    const onThumbnailError = event => {
      // Thumbnail yüklenemezse placeholder gösterilebilir
      event.target.style.display = "none";
    };
    const triggerFileInput = () => {
      if (
        !previewPageNo.value ||
        !newData.value.categoryId ||
        !newData.value.id
      ) {
        alert("Lütfen önce sayfa numarası girin ve ders notu seçin.");
        return;
      }
      fileInputRef.value?.click();
    };
    const handleFileUpload = async event => {
      const file = event.target.files?.[0];
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        alert("Lütfen bir resim dosyası seçin.");
        return;
      }

      uploadingImage.value = true;

      try {
        // Sayfa numarasını 3 haneli formatla
        const pageNoFormatted = parseInt(previewPageNo.value)
          .toString()
          .padStart(3, "0");

        // Dosya adını oluştur: sayfa numarası + _ + timestamp + .jpg
        const timestamp = Date.now();
        const fileExtension = file.name.split(".").pop() || "jpg";
        const fileName = `${pageNoFormatted}_${timestamp}.${fileExtension}`;

        // Dosyayı base64'e çevir
        const reader = new FileReader();
        reader.onload = async e => {
          try {
            const base64String = e.target.result.split(",")[1]; // data:image/...;base64, kısmını çıkar

            // Klasör yolu: referansnotlari/{workFolder}/ref_img_{usertype}/{categoryId}/{lessonNoteId}
            // Dosyalar direkt lessonNoteId klasörüne yüklenir, sayfa numarası klasörü yok
            const folderPath =
              "referansnotlari/" +
              store.state.workFolder +
              "/ref_img_" +
              store.state.usertype +
              "/" +
              newData.value.categoryId +
              "/" +
              newData.value.id;

            const location = folderPath + "/" + fileName;

            // API'ye gönder
            const result = await store.dispatch("postDatas", {
              api: "references/saveimages",
              data: [
                {
                  ImageString: base64String,
                  Location: location,
                  isImg: true
                }
              ]
            });

            console.log("[DEBUG] handleFileUpload - API response:", result);

            // Response formatını kontrol et (result veya Result olabilir)
            const isSuccess =
              result &&
              (result.result === true ||
                result.Result === true ||
                result.result === "true" ||
                result.Result === "true");
            debugger;

            if (isSuccess) {
              //alert("Resim başarıyla yüklendi!");

              // Resim listesini yenile - önce mevcut listeyi temizle
              imageFileNames.value = [];

              // Kısa bir gecikme ekle (dosyanın diske yazılması için)
              await new Promise(resolve => setTimeout(resolve, 500));

              // Resim listesini yeniden yükle
              await loadImageFileNames();

              console.log(
                "[DEBUG] handleFileUpload - Resim listesi yenilendi, toplam resim sayısı:",
                imageFileNames.value.length
              );
            } else {
              console.error(
                "[DEBUG] handleFileUpload - Upload failed, response:",
                result
              );
              alert(
                "Resim yüklenirken bir hata oluştu. Response: " +
                  JSON.stringify(result)
              );
            }
          } catch (error) {
            console.error("Resim yükleme hatası:", error);
            alert("Resim yüklenirken bir hata oluştu: " + error.message);
          } finally {
            uploadingImage.value = false;
            // File input'u temizle
            if (fileInputRef.value) {
              fileInputRef.value.value = "";
            }
          }
        };
        reader.onerror = () => {
          alert("Dosya okunurken bir hata oluştu.");
          uploadingImage.value = false;
        };
        reader.readAsDataURL(file);
      } catch (error) {
        console.error("Resim yükleme hatası:", error);
        alert("Resim yüklenirken bir hata oluştu: " + error.message);
        uploadingImage.value = false;
      }
    };

    const saveLine = async d => {
      await store.dispatch("postDatas", {
        api: "categories/addcategory",
        data: d
      });
      listData.value = await getList();
    };
    const saveCatsLine = async d => {
      await store.dispatch("postDatas", {
        api: "categories/addcategory",
        data: d
      });
      listData.value = await getList();
    };
    const saveNew = async () => {
      var str = "";
      var ln = Object.keys(newData.value.pages).length;
      Object.keys(newData.value.pages).forEach((p, i) => {
        str =
          str +
          newData.value.pages[p][0].padStart(3, "0") +
          "-" +
          newData.value.pages[p][1].padStart(3, "0");
        str += i === ln - 1 ? "" : "#";
      });
      newData.value.pageNo = str;
      delete newData.value.pages;
      await store.dispatch("postDatas", {
        api: "notes/addnote",
        data: newData.value
      });
      newPanel.value = false;
      listData.value = await getList();
    };
    const openCats = async () => {
      catsPanel.value = true;
      catsListData.value = await getCatsList();
      catsloaded.value = true;
    };
    watch(
      () => selectedcat.value,
      async () => {
        listData.value = await getList();
      }
    );
    onBeforeMount(async () => {
      await store.dispatch("getWorkFolder");
      branchList.value = await getBranchList();
      noteCats.value = await getCatsList();
      loaded.value = true;
    });
    return {
      headdata,
      opts,
      catsheaddata,
      catsopts,
      filteredList,
      saveLine,
      addFunc,
      loaded,
      selectedcat,
      branchList,
      newPanel,
      selectedAddCat,
      newData,
      noteCats,
      fassiculeCount,
      fassiculeChange,
      saveNew,
      q,
      searchfilter,
      qc,
      searchcatsfilter,
      catsPanel,
      openCats,
      catsloaded,
      saveCatsLine,
      catsListData,
      noteSelect,
      selectednote,
      canSaveNote,
      previewPageNo,
      previewImageUrl,
      imageError,
      onPreviewPageNoChange,
      onImageError,
      imageFileNames,
      loadingImages,
      selectedImageFileName,
      getImageUrl,
      selectImage,
      onThumbnailError,
      fileInputRef,
      uploadingImage,
      triggerFileInput,
      handleFileUpload,
      showDefaultImageModal,
      modalOriginalFileName,
      modalSelectedFileName,
      modalProcessing,
      confirmSetDefaultImage
    };
  }
};
</script>
<style scoped>
.image-scroll-container {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 12px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
  max-height: 200px;
}

.image-scroll-container::-webkit-scrollbar {
  height: 8px;
}

.image-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.image-scroll-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.image-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 120px;
  cursor: pointer;
  padding: 8px;
  border: 2px solid transparent;
  border-radius: 4px;
  transition: all 0.2s;
  background-color: #fff;
}

.image-item:hover {
  border-color: #4caf50;
  background-color: #f0f8f0;
}

.image-item.selected {
  border-color: #2196f3;
  background-color: #e3f2fd;
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.3);
}

.image-item img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.image-filename {
  font-size: 11px;
  color: #666;
  margin-top: 4px;
  text-align: center;
  word-break: break-all;
  max-width: 100px;
}

/* Varsayılan resim modal tasarımı */
.default-image-modal {
  max-width: 420px;
  width: 90vw;
}

.default-image-modal-content {
  min-height: auto;
  max-height: 70vh;
}

.default-image-modal-text {
  margin-bottom: 16px;
  color: #333;
  line-height: 1.6;
  text-align: center;
}

.default-image-modal-title {
  margin-bottom: 16px;
  font-size: 15px;
}

.default-image-modal-box {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 12px;
  text-align: left;
}

.default-image-modal-row {
  margin-bottom: 8px;
}

.default-image-modal-old {
  color: #d32f2f;
  font-weight: 500;
  margin-top: 4px;
}

.default-image-modal-new {
  color: #2e7d32;
  font-weight: 500;
  margin-top: 4px;
}

.default-image-modal-note {
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 10px;
  border-radius: 4px;
  font-size: 13px;
  color: #856404;
  text-align: left;
}

.default-image-modal-actions {
  margin-top: auto;
  padding-top: 16px;
}

.image-item-add {
  border: 2px dashed #ccc;
  background-color: #fafafa;
  justify-content: center;
}

.image-item-add:hover {
  border-color: #4caf50;
  background-color: #f0f8f0;
}

.add-image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  color: #999;
  font-weight: 600;
}
</style>
